import { logger } from '../../../utils/logger';
import { getSkillsList } from './list';
import type { TransferSkill } from '../types';

function isVoiceSkill(skill: TransferSkill): boolean {
  return skill.isActive && (skill.mediaType === 'Phone Call' || skill.mediaType === 'Voice');
}

function parseSkillId(skill: TransferSkill): number {
  return parseInt(skill.skillId, 10);
}

function findDefaultOutboundSkill(voiceSkills: TransferSkill[]): TransferSkill | undefined {
  return voiceSkills.find((s) => s.skillName.toLowerCase().includes('default outbound'));
}

function findManualOutboundSkill(voiceSkills: TransferSkill[]): TransferSkill | undefined {
  return voiceSkills.find(
    (s) =>
      s.isOutbound === true && !s.outboundStrategy?.toLowerCase().includes('personal connection')
  );
}

function findNamedOutboundSkill(voiceSkills: TransferSkill[]): TransferSkill | undefined {
  return voiceSkills.find((s) => {
    const name = s.skillName.toLowerCase();
    return name.includes('outbound') && !name.includes('pc ') && !name.includes('personal');
  });
}

export async function resolveOutboundSkillId(): Promise<number | undefined> {
  logger.debug('[CXone SDK] Looking for outbound skill...');
  try {
    const skills = await getSkillsList();
    const voiceSkills = skills.filter(isVoiceSkill);
    logger.debug('[CXone SDK] Voice skills:', voiceSkills.length);

    const resolvers = [
      findDefaultOutboundSkill,
      findManualOutboundSkill,
      findNamedOutboundSkill,
      (list: TransferSkill[]) => list.find((s) => s.isOutbound === true),
      (list: TransferSkill[]) => list[0],
    ];

    for (const resolver of resolvers) {
      const match = resolver(voiceSkills);
      if (match) {
        logger.debug('[CXone SDK] Selected outbound skill:', match.skillName, match.skillId);
        return parseSkillId(match);
      }
    }

    logger.debug('[CXone SDK] No voice skills available');
  } catch (error) {
    logger.error('[CXone SDK] resolveOutboundSkillId failed:', error);
  }
  return undefined;
}
